import { observer } from "mobx-react-lite";

import { DateTime, TIME_FORMATS } from "@bps/date-time";
import { FontSizes, Stack, Text, useTheme } from "@bps/fluent-ui";
import { OutboundCommStatusesEnumText } from "@libs/gateways/booking/BookingGateway.dtos.ts";
import { CalendarEventReminderSearchModel } from "@stores/booking/models/CalendarEventReminderSearchModel.ts";

import { EventReminderStatesText } from "../EventReminderScreen.types.ts";

interface EventReminderListSmsProps {
  item: CalendarEventReminderSearchModel;
}

export const EventReminderListSms: React.FC<EventReminderListSmsProps> =
  observer(({ item }) => {
    const theme = useTheme();

    const apptRemPreferences =
      item.patient?.contactPreferences?.apptRemPreferences;

    if (apptRemPreferences?.contactHasOptedOut) {
      return <Text>Opted out</Text>;
    }

    const status = item.message?.deliveryStatusCode;
    const statusText = status
      ? OutboundCommStatusesEnumText[
          status as keyof typeof OutboundCommStatusesEnumText
        ]
      : EventReminderStatesText.NotSent;

    const dateTime = item.message?.deliveryStatusUpdatedDateTime
      ? DateTime.fromISO(item.message.deliveryStatusUpdatedDateTime)
      : undefined;

    return (
      <Stack>
        <span>{statusText}</span>
        {dateTime && (
          <span
            style={{
              color: theme.palette.neutralSecondary,
              fontSize: FontSizes.size12
            }}
          >
            {dateTime.toDayDefaultFormat()}{" "}
            {dateTime.toFormat(TIME_FORMATS.DEFAULT_TIME_FORMAT)}
          </span>
        )}
      </Stack>
    );
  });
